/**
 * Dashboard → list deep-link filter presets.
 * List pages read `?filter=` (and related params) to open a focused subset.
 */

export type SpeciesListFilter =
  | 'recent'
  | 'attention'
  | 'conservation'
  | 'withPhotos';

export type BirdListFilter =
  | 'recentlyHatched'
  | 'juveniles'
  | 'attention';

export type BreedingListFilter = 'productive' | 'attention';

export type ClutchListFilter = 'recent' | 'thisYear';

export function speciesListPath(filter?: SpeciesListFilter): string {
  return filter ? `/species?filter=${filter}` : '/species';
}

export function birdsListPath(
  options?: { filter?: BirdListFilter; status?: string },
): string {
  const params = new URLSearchParams();
  if (options?.filter) params.set('filter', options.filter);
  if (options?.status) params.set('status', options.status);
  const qs = params.toString();
  return qs ? `/birds?${qs}` : '/birds';
}

export function breedingListPath(
  options?: { filter?: BreedingListFilter; status?: 'active' | 'ended' },
): string {
  const params = new URLSearchParams();
  if (options?.filter) params.set('filter', options.filter);
  if (options?.status) params.set('status', options.status);
  const qs = params.toString();
  return qs ? `/breeding?${qs}` : '/breeding';
}

export function clutchesListPath(
  options?: { filter?: ClutchListFilter; status?: string },
): string {
  const params = new URLSearchParams();
  if (options?.filter) params.set('filter', options.filter);
  if (options?.status) params.set('status', options.status);
  const qs = params.toString();
  return qs ? `/clutches?${qs}` : '/clutches';
}

export function daysAgo(days: number): Date {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d;
}
